// cache names for use across parts of the application - eg in sw and in app
export default {
  graphql: "graphql",
  images: "images",
  videos: "videos",
};
